export default __webpack_public_path__ + "static/media/32_p.o._destiny.f8fd8ae7.png";